import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _orderBy from 'lodash/orderBy';

import { getPrizeListApi } from 'api/client';
import { prizeTypes } from 'config/promoPrizeTypes';
import { setUserWinnerPrize } from 'client/redux/modules/userWinnerPrize';
import { setMGMReferral } from 'client/redux/modules/mgmReferral';

import useIsInitSuccessInfo from 'client/hooks/useIsInitSuccessInfo';
import useClientErrorHandler from 'client/hooks/useClientErrorHandler';

export default function useUpdateWinnerData() {
    const dispatch = useDispatch();
    const errHandler = useClientErrorHandler();
    const isInitSuccess = useIsInitSuccessInfo();
    const { uuid: promoUUID } = useSelector(s => s.promo);
    const { isLogin } = useSelector(s => s.userLoginState);
    const { hasUserWinnerPrizeListReady, isMgmShare, isMgmSelf } = useSelector(s => s.flags);
    const { mgmReferral: { uuid: mgmPromoUUID } = {} } = useSelector(s => s.mgmRelation);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        async function get() {
            try {
                if (!hasUserWinnerPrizeListReady) {
                    await getPrizeList();
                }
            } catch (err) {
                errHandler({ err });
            } finally {
                setIsFetching(false);
            }
        }
        if (isInitSuccess && isLogin) {
            get();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isInitSuccess, isLogin, hasUserWinnerPrizeListReady]);

    async function getPrizeList() {
        const winnerLists = await getUserWinnerList(promoUUID);
        dispatch(setUserWinnerPrize(winnerLists));
        if (isMgmShare || isMgmSelf) {
            const winnerLists = await getUserWinnerList(mgmPromoUUID);
            dispatch(setMGMReferral({ userWinnerPrize: winnerLists }));
        }
    }

    return { isFetching };
}

export async function getUserWinnerList(promoUUID) {
    const {
        payload: { winners = [], winnerQualify = [] }
    } = await getPrizeListApi(promoUUID);
    const { winnerPrizes, thankPrizes } = splitThanksPrize(sortPrize(winners));
    return {
        winnerPrizes,
        thankPrizes,
        unOpenWinnerPrize: winnerQualify
    };
}
function sortPrize(prizes = []) {
    return _orderBy(prizes, ['entryId'], ['desc']);
}
function splitThanksPrize(winners = []) {
    return winners.reduce(
        (obj, winner) => {
            if (winner.prize.type === prizeTypes.THANKYOU) {
                obj.thankPrizes.push(winner);
            } else {
                obj.winnerPrizes.push(winner);
            }
            return obj;
        },
        { winnerPrizes: [], thankPrizes: [] }
    );
}
